<div class="container" [class.autocomplete]="autocompleteValues && autocompleteValues.length">
    @if (title) {
        <span class="body-medium" [innerHTML]="title"></span>
    }
    @if (helperText) {
        <span class="helper-text footnote-regular">{{ helperText }}</span>
    }
    <ion-item
        class="input-item"
        [class.error]="
            (checkDirty &&
                controlDir &&
                (controlDir.control?.dirty || controlDir.control?.touched) &&
                !controlDir.control?.valid) ||
            error
        "
        lines="none"
        [class.disabled]="disabled"
    >
        @if (icon && iconPosition === 'start') {
            <div class="input-icon">
                <ion-icon [src]="'assets/icon/input/' + icon" color="white"> </ion-icon>
            </div>
        }
        <ion-input
            [type]="type"
            [placeholder]="placeholder"
            [attr.aria-label]="title"
            [value]="value"
            (ionInput)="onInputChanged($event)"
            [disabled]="disabled"
            [inputmode]="inputmode"
        >
        </ion-input>
        @if (icon && iconPosition === 'end') {
            <div class="input-icon">
                <ion-icon [src]="'assets/icon/input/' + icon" color="white"> </ion-icon>
            </div>
        }
        @if ((type === 'password' || passwordIcon) && !disabled) {
            <a (click)="togglePassword()" class="input-password-button">
                <ion-label class="input-password-button-label">
                    <ion-icon [src]="passwordIcon ? 'assets/icon/input/visible.svg' : 'assets/icon/input/hidden.svg'" />
                </ion-label>
            </a>
        }
    </ion-item>
    @if (autocompleteValues && autocompleteValues.length && !suggestionSelected) {
        <div class="autocomplete-container">
            <ion-list class="autocomplete-results">
                @for (suggestion of autocompleteValues; track suggestion.label) {
                    <ion-item class="ion-no-padding" (click)="selectAutcompleteValue(suggestion)">
                        <ion-label
                            ><span [innerHTML]="sanitizer.bypassSecurityTrustHtml(suggestion.label)"></span
                        ></ion-label>
                    </ion-item>
                }
            </ion-list>
        </div>
    }
</div>
